"use client";

import Image from "next/image";

import classNames from "classnames";
import type { ShopperBasketsTypes } from "commerce-sdk-isomorphic";

import { SalesPrice } from "@/components/salesPrice/salesPrice.component";
import { Text } from "@/components/text/text.component";

import { brown } from "@/app/font";
import { GetCartLineProductsQueryResult } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const ToastOrderSummaryLineItem = ({
  product,
  item,
  isBonusLineItem,
}: ToastOrderSummaryLineItemProps) => {
  const image = product?.featuredImage?.image
    ? urlFor(product?.featuredImage?.image).width(120).height(120).url()
    : null;
  return (
    <div className="flex items-center gap-6 border-b border-b-[#80808033] py-1 last:border-0">
      <div className="shrink-0 overflow-hidden rounded-2xl bg-white">
        {image ? (
          <Image
            src={image}
            alt={product?.featuredImage?.alt ?? ""}
            width={80}
            height={80}
            className="rounded-lg object-cover"
          />
        ) : null}
      </div>
      <section className="flex flex-1 flex-col">
        <Text variant="body2" className="text-greyscale-body flex-1">
          {product?.name || item.productName}
        </Text>
        {product?.type !== "kit" ? <Text>Qty: {item.quantity}</Text> : null}
      </section>
      <div className="flex shrink-0 items-start">
        <SalesPrice
          listPrice={item.listPrice}
          salesPrice={item.salesPrice}
          quantity={item.quantity}
          free={item.priceFree || isBonusLineItem}
          salesPriceClassName={classNames(brown.className, "subtitle-2")}
          reverse
        />
      </div>
    </div>
  );
};

type ToastOrderSummaryLineItemProps = {
  product?: GetCartLineProductsQueryResult[number];
  item: ShopperBasketsTypes.ProductItem;
  isBonusLineItem?: boolean;
  action?: (
    prevState: ResponseMessage,
    formData: FormData,
  ) => ResponseMessage | Promise<ResponseMessage>;
};
